<div class="betslip-digital-single-bet-pick-stake-list">
    <bs-digital-pick-list>
        <bs-digital-single-bet-pick
            *rxFor="let pick of orderedPickList$; trackBy: pickTrackBy; renderCallback: onListRendered$"
            [pick]="pick"
            [singleBetPick]="singleBetPick(singleBetState(), pick)"
            [isMultiSingleBet]="isMultiSingleBet()"
            [oddsDisplayFormat]="oddsDisplayFormat"
            [removeButtonPosition]="removeButtonPosition"
            [removeButtonStyle]="removeButtonStyle"
            [alwaysShowStakeInput]="alwaysShowStakeInput"
            [msAutomation]="pick.id.toString()"
            [isLinear]="false">
        </bs-digital-single-bet-pick>
    </bs-digital-pick-list>
</div>

@if (isListRendered()) {
    <bs-digital-picks-toolbar [picks]="singleBetState().picks"></bs-digital-picks-toolbar>
}
